import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'clsx';
import styles from 'src/components/SlideIndicator.scss';


const SlideIndicator = ({ active, action }) => (
  <button
    className={
      classNames(
        styles.indicator,
        { [styles['indicator--active']]: active }
      )
    }
    data-test={ active ? 'button-slider-indicator-active' : 'button-slider-indicator' }
    onClick={ action }
    type="button"
  />
);

SlideIndicator.propTypes = {
  action: PropTypes.func.isRequired,
  active: PropTypes.bool.isRequired
};

export default SlideIndicator;
